var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar',{staticStyle:{"min-height":"45px"}}),_c('router-view',{staticClass:"pb-5",staticStyle:{"min-height":"calc(100vh - 111px)"}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }